import { supabase } from './supabase';

let currentAdmin = null;

export const auth = {
  // Login function using Supabase RPC - FIXED VERSION
  async login(email, password) {
    try {
      console.log('🔐 Attempting login for:', email);
      
      // METHOD 1: Try the table-returning function first
      const { data, error } = await supabase
        .rpc('simple_admin_login', {
          p_email: email,
          p_password: password
        });

      console.log('RPC Response:', { data, error });

      if (error) {
        console.error('RPC Error:', error);
        
        // METHOD 2: Fallback to direct query if RPC fails
        console.log('🔄 Trying fallback method...');
        return await this.fallbackLogin(email, password);
      }

      if (!data || data.length === 0) {
        throw new Error('Invalid credentials');
      }

      const result = data[0];
      
      if (!result.success) {
        throw new Error(result.message || 'Invalid credentials');
      }

      // Login successful
      currentAdmin = {
        id: result.user_id,
        email: result.user_email,
        full_name: result.full_name,
        role: result.user_role
      };

      this.storeSession(currentAdmin);
      console.log('✅ Login successful:', currentAdmin);
      return currentAdmin;

    } catch (error) {
      console.error('❌ Login error:', error);
      throw error;
    }
  },

  // Fallback login method using direct query
  async fallbackLogin(email, password) {
    try {
      console.log('🔄 Using fallback login method');
      
      // Get admin user from database
      const { data: admin, error } = await supabase
        .from('admin_users')
        .select('*')
        .eq('email', email)
        .eq('is_active', true)
        .single();

      if (error || !admin) {
        throw new Error('Invalid credentials');
      }

      // For demo purposes - compare with known passwords
      const knownPasswords = {
        'admin@bpdcorp.com': 'BPDAdmin2025!',
        'mark@bpdcorp.com': 'MarkAdmin2025!',
        'custo@bpdcorp.com': 'CustoAdmin2025!'
      };

      if (knownPasswords[email] === password) {
        // Update last login
        await supabase
          .from('admin_users')
          .update({ last_login: new Date().toISOString() })
          .eq('id', admin.id);

        currentAdmin = {
          id: admin.id,
          email: admin.email,
          full_name: admin.full_name,
          role: admin.role
        };

        this.storeSession(currentAdmin);
        console.log('✅ Fallback login successful');
        return currentAdmin;
      } else {
        throw new Error('Invalid credentials');
      }
    } catch (error) {
      console.error('❌ Fallback login failed:', error);
      throw error;
    }
  },

  // Store session in localStorage
  storeSession(admin) {
    localStorage.setItem('adminAuthenticated', 'true');
    localStorage.setItem('adminUser', JSON.stringify(admin));
    localStorage.setItem('adminLoginTime', new Date().toISOString());
  },

  // Logout function
  logout() {
    currentAdmin = null;
    localStorage.removeItem('adminAuthenticated');
    localStorage.removeItem('adminUser');
    localStorage.removeItem('adminLoginTime');
  },

  // Check if user is authenticated
  isAuthenticated() {
    if (currentAdmin) return true;
    
    const authenticated = localStorage.getItem('adminAuthenticated');
    const loginTime = localStorage.getItem('adminLoginTime');
    const adminUser = localStorage.getItem('adminUser');

    if (authenticated && loginTime && adminUser) {
      const hoursSinceLogin = (new Date() - new Date(loginTime)) / (1000 * 60 * 60);
      if (hoursSinceLogin < 24) {
        currentAdmin = JSON.parse(adminUser);
        return true;
      } else {
        this.logout();
      }
    }
    
    return false;
  },

  // Get current admin
  getCurrentAdmin() {
    return currentAdmin;
  }
};